// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.month-range-picker-container {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
}

.custom-month-picker {
  width: 200px !important;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #d6e2f1;
  background: #ffffff;
  box-shadow: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.custom-month-picker:hover {
  border-color: #c3d4e8 !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
}

.custom-month-picker.ant-picker-focused,
.custom-month-picker.ant-picker-status-success.ant-picker-focused,
.custom-month-picker.ant-picker-focused:hover {
  border-color: #b9cde4 !important;
  box-shadow: 0 0 0 3px rgba(185, 205, 228, 0.24) !important;
}

.custom-month-picker .ant-picker-input > input {
  font-size: 14px;
  color: #0f172a;
}

.custom-month-picker .ant-picker-input > input::placeholder {
  color: #8a9bb8;
}

.custom-month-picker .ant-picker-suffix {
  color: #a0aec0;
}

.dashboard-date-picker {
  width: 200px !important;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #d6e2f1;
  background: #ffffff;
  box-shadow: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.dashboard-date-picker:hover {
  border-color: #c3d4e8 !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
}

.dashboard-date-picker.ant-picker-focused,
.dashboard-date-picker.ant-picker-status-success.ant-picker-focused,
.dashboard-date-picker.ant-picker-focused:hover {
  border-color: #b9cde4 !important;
  box-shadow: 0 0 0 3px rgba(185, 205, 228, 0.24) !important;
}

.dashboard-date-picker .ant-picker-input > input {
  font-size: 14px;
  color: #0f172a;
}

.dashboard-date-picker .ant-picker-input > input::placeholder {
  color: #64748b;
}

.dashboard-date-picker .ant-picker-suffix {
  color: #9aa4b2;
}

.dashboard-date-dropdown .ant-picker-panel-container {
  width: 290px !important;
  min-width: 240px !important;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.month-range-picker__start-wrapper,
.month-range-picker__end-wrapper {
  position: relative;
  display: inline-block;
}

.month-range-picker__lock-tooltip {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  min-width: 260px;
  max-width: 300px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  pointer-events: none;
}
.month-range-picker__lock-tooltip__bar {
  width: 4px;
  background: #2b74e4;
  flex-shrink: 0;
}
.month-range-picker__lock-tooltip__content {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.month-range-picker__lock-tooltip__title {
  font-size: 12px;
  font-weight: 700;
  color: #03045e;
}
.month-range-picker__lock-tooltip__body {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
  margin: 0;
}
.month-range-picker__lock-tooltip__example {
  font-size: 11px;
  color: #6b7280;
  opacity: 0.85;
}

.month-range-picker__vs {
  color: #0f172a;
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  flex-shrink: 0;
}

.custom-month-dropdown .ant-picker-panel-container {
  width: 290px !important;
  min-width: 240px !important;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.custom-month-dropdown .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
.custom-month-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
.custom-month-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
  background: #0f4a97;
  border-radius: 999px;
}

.custom-month-dropdown .ant-picker-cell-in-view.ant-picker-cell-in-range::before {
  background: rgba(15, 74, 151, 0.12);
}

.custom-month-dropdown .ant-picker-content {
  font-size: 12px;
}

@media (max-width: 900px) {
  .month-range-picker-container {
    flex-wrap: wrap;
  }
  .month-range-picker__vs {
    display: none;
  }
}
@media (max-width: 600px) {
  .month-range-picker-container {
    width: 100%;
  }
  .custom-month-picker {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/MonthRangePicker/MonthRangePicker.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0DAAA;AACF;;AAEA;EACE,gCAAA;EACA,uDAAA;AACF;;AAEA;;;EAGE,gCAAA;EACA,0DAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0DAAA;AACF;;AAEA;EACE,gCAAA;EACA,uDAAA;AACF;;AAEA;;;EAGE,gCAAA;EACA,0DAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,0CAAA;AACF;;AAEA;;EAEE,kBAAA;EACA,qBAAA;AACF;;AAGA;EACE,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,oBAAA;AAAF;AAEE;EACE,UAAA;EACA,mBAAA;EACA,cAAA;AAAJ;AAGE;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADJ;AAIE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAFJ;AAKE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AAHJ;AAME;EACE,eAAA;EACA,cAAA;EACA,aAAA;AAJJ;;AAQA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AALF;;AAQA;EACE,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,0CAAA;AALF;;AAQA;;;EAGE,mBAAA;EACA,oBAAA;AALF;;AAQA;EACE,mCAAA;AALF;;AAQA;EACE,eAAA;AALF;;AAQA;EACE;IACE,eAAA;EALF;EAQA;IACE,aAAA;EANF;AACF;AASA;EACE;IACE,WAAA;EAPF;EAUA;IACE,sBAAA;EARF;AACF","sourcesContent":[".month-range-picker-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: nowrap;\n}\n\n.custom-month-picker {\n  width: 200px !important;\n  height: 44px;\n  border-radius: 8px;\n  border: 1px solid #d6e2f1;\n  background: #ffffff;\n  box-shadow: none;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.custom-month-picker:hover {\n  border-color: #c3d4e8 !important;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;\n}\n\n.custom-month-picker.ant-picker-focused,\n.custom-month-picker.ant-picker-status-success.ant-picker-focused,\n.custom-month-picker.ant-picker-focused:hover {\n  border-color: #b9cde4 !important;\n  box-shadow: 0 0 0 3px rgba(185, 205, 228, 0.24) !important;\n}\n\n.custom-month-picker .ant-picker-input > input {\n  font-size: 14px;\n  color: #0f172a;\n}\n\n.custom-month-picker .ant-picker-input > input::placeholder {\n  color: #8a9bb8;\n}\n\n.custom-month-picker .ant-picker-suffix {\n  color: #a0aec0;\n}\n\n.dashboard-date-picker {\n  width: 200px !important;\n  height: 44px;\n  border-radius: 8px;\n  border: 1px solid #d6e2f1;\n  background: #ffffff;\n  box-shadow: none;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.dashboard-date-picker:hover {\n  border-color: #c3d4e8 !important;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;\n}\n\n.dashboard-date-picker.ant-picker-focused,\n.dashboard-date-picker.ant-picker-status-success.ant-picker-focused,\n.dashboard-date-picker.ant-picker-focused:hover {\n  border-color: #b9cde4 !important;\n  box-shadow: 0 0 0 3px rgba(185, 205, 228, 0.24) !important;\n}\n\n.dashboard-date-picker .ant-picker-input > input {\n  font-size: 14px;\n  color: #0f172a;\n}\n\n.dashboard-date-picker .ant-picker-input > input::placeholder {\n  color: #64748b;\n}\n\n.dashboard-date-picker .ant-picker-suffix {\n  color: #9aa4b2;\n}\n\n.dashboard-date-dropdown .ant-picker-panel-container {\n  width: 290px !important;\n  min-width: 240px !important;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n}\n\n.month-range-picker__start-wrapper,\n.month-range-picker__end-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n\n.month-range-picker__lock-tooltip {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  display: flex;\n  min-width: 260px;\n  max-width: 300px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n  pointer-events: none;\n\n  &__bar {\n    width: 4px;\n    background: #2b74e4;\n    flex-shrink: 0;\n  }\n\n  &__content {\n    padding: 8px 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  &__title {\n    font-size: 12px;\n    font-weight: 700;\n    color: #03045e;\n  }\n\n  &__body {\n    font-size: 12px;\n    color: #6b7280;\n    line-height: 1.5;\n    margin: 0;\n  }\n\n  &__example {\n    font-size: 11px;\n    color: #6b7280;\n    opacity: 0.85;\n  }\n}\n\n.month-range-picker__vs {\n  color: #0f172a;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.custom-month-dropdown .ant-picker-panel-container {\n  width: 290px !important;\n  min-width: 240px !important;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n}\n\n.custom-month-dropdown .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,\n.custom-month-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,\n.custom-month-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {\n  background: #0f4a97;\n  border-radius: 999px;\n}\n\n.custom-month-dropdown .ant-picker-cell-in-view.ant-picker-cell-in-range::before {\n  background: rgba(15, 74, 151, 0.12);\n}\n\n.custom-month-dropdown .ant-picker-content {\n  font-size: 12px;\n}\n\n@media (max-width: 900px) {\n  .month-range-picker-container {\n    flex-wrap: wrap;\n  }\n\n  .month-range-picker__vs {\n    display: none;\n  }\n}\n\n@media (max-width: 600px) {\n  .month-range-picker-container {\n    width: 100%;\n  }\n\n  .custom-month-picker {\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
